export const validationAccount = {
  lastName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  firstName: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  email: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'email',
      message: 'Ce n\'est pas un email valide !'
    }
  ],
  city: [
    {
      type: 'required',
      expected: false,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'city',
      message: 'Ce n\'est pas une ville valide !'
    }
  ],
  zipCode: [
    {
      type: 'type',
      expected: 'zipcode',
      message: 'Ce n\'est pas un code postal valide !'
    }
  ],
  phone: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  gardenSurface: [
    {
      type: 'type',
      expected: 'numeric',
      message: 'Une valeur positive est attendue'
    }
  ],
  password: [
    {
      type: 'minLength',
      expected: 7,
      required: false,
      message: 'Votre mot de passe doit faire plus de 7 caractères !'
    }
  ],
  passwordConfirm: []
}

export const validationAvanceImmediate = {
  nomNaissance: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  prenoms: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  civilite: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  adresseMail: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'email',
      message: 'Ce n\'est pas un email valide !'
    }
  ],
  city: [
    {
      type: 'required',
      expected: false,
      message: 'Ce champ est obligatoire'
    },
    {
      type: 'type',
      expected: 'city',
      message: 'Ce n\'est pas une ville valide !'
    }
  ],
  villeResidenceCodePostal: [
    {
      type: 'type',
      expected: 'zipcode',
      message: 'Ce n\'est pas un code postal valide !'
    },
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  villeNaissanceCodePostal: [
    {
      type: 'type',
      expected: 'zipcode',
      message: 'Ce n\'est pas un code postal valide !'
    },
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  numeroTelephonePortable: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  bic: [
    {
      type: 'type',
      expected: 'bic',
      message: 'Ce n\'est pas un identifiant BIC valide !'
    }, {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  iban: [
    {
      type: 'type',
      expected: 'iban',
      message: 'Ce n\'est pas un identifiant IBAN valide !'
    }, {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ],
  titulaire: [
    {
      type: 'required',
      expected: true,
      message: 'Ce champ est obligatoire'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/customer/validators.js